import { Component, Input, OnInit } from '@angular/core';
import { SetParagrafoImmagine } from 'src/app/shared/models/node';

@Component({
  selector: 'app-sample-text-with-image',
  templateUrl: './sample-text-with-image.component.html',
  styleUrls: ['./sample-text-with-image.component.scss']
})
export class SampleTextWithImageComponent implements OnInit {

  @Input() block: any;
  @Input() cols: any;

  constructor() { }

  ngOnInit(): void {
  }

}
